<template>
<div class="basket__discount">
  <p>{{locale.have_discount_code}}</p>
  <input type="text"
         v-model="code">
  <button class="btn btn--dark btn--rounded"
          @click.prevent="addDiscountCode"
          v-html="locale.apply">
  </button>
</div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      code: '',
    };
  },
  computed: {
    ...mapGetters([
      'locale',
    ]),
  },
  methods: {
    addDiscountCode() {
      // TODO: Show error in flash bar if code invalid
      if (this.code.length > 0) {
        this.$store.dispatch('addDiscountCode', this.code)
          .then((success) => {
            if (success) { this.code = ''; }
          });
      }
    },
  },
};
</script>
